module.exports = __webpack_public_path__ + "img/face-2.33a2578f.png";